











































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
  components: {}
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.MerchantConcurrentStatisticsServiceProxy();
  }
  input: proxy.MerchantConCurrentPageInputDto = new proxy.MerchantConCurrentPageInputDto();
  mintes=[
      {
          key:'最近一分钟',
          value:1
      }
  ]
  zong=0;
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },

    // {
    //   title: '商户号',
    //   key: 'mid',
    // },
    {
      title: '名称',
      key: 'merchantName',
    },
    {
      title: '并发数量',
      key: 'conCurrentNum'
    }
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;

    this.input.minute = this.mintes[0].value;
    this.prox.statisticsMerchantConCurrentList(this.input).then(x => {
      this.dataList = x;
      this.zong = 0;
      this.dataList.map(x=>{
          this.zong +=x.conCurrentNum
      })
      this.showPaging(x);
    });
  }

  getpage() {
    this.OnInit();
  }
  async created() {
    this.input.tongJiEnumName = 0;
    this.getpage();
  }

}
